<template>
  <!-- Price Description -->
  <div class="flex flex-row justify-center my-1.5 relative z-50">
    <div class="md:w-full text-center">
      <p
        class="price-color text-[13px]"
        v-if="authStore.getLandingPageLanguage == 'en'"
      >
        This service is available to Mobily customers for {{ price }} SAR (including VAT) renewed {{ period }}. To cancel your subscription please : <a href="http://infomob.digitalcg.net/" class="underline text-pink-500">click here</a>
      </p>
      <p
        dir="rtl"
        class="price-color text-[13px]"
        v-if="authStore.getLandingPageLanguage == 'ar'"
      >
        هذه الخدمة متاحة لعملاء موبايلي مقابل {{ price }} ريال، يتم تجديدها {{ period }}. (شامل قيمة الضريبة المضافة) لالغاء اشتراكك الرجاء زيارة الموقع <a href="http://infomob.digitalcg.net/" class="underline text-pink-500">إضغط هنا</a>
      </p>
    </div>
  </div>
  <!-- End Of Price Description -->
</template>

<script>
import { useAuthStore } from "@/stores/auth";

export default {
  name: "LandingPrice",
  props: {
    period: {
      type: String,
      default: "",
    },
    price: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      authStore: useAuthStore(),
    };
  },
};
</script>

<style>
.price-color {
  color: #9d2890;
}
</style>
